import { createFileRoute, notFound } from "@tanstack/react-router";
import { ApiError } from "@/api/client";
import {
  productQuery,
  productReviewsInfiniteQuery,
  relatedProductsQuery,
} from "@/api/queries/products";
import { ProductPage } from "@/pages/product/ProductPage";
import { ProductPageSkeleton } from "@/pages/product/ProductPageSkeleton";

export const Route = createFileRoute("/_app/p/$slug")({
  loader: async ({ context, params }) => {
    try {
      const product = await context.queryClient.ensureQueryData(productQuery(params.slug));
      void context.queryClient.prefetchQuery(relatedProductsQuery(params.slug));
      void context.queryClient.prefetchInfiniteQuery(productReviewsInfiniteQuery(params.slug));
      return product;
    } catch (error) {
      if (error instanceof ApiError && error.status === 404) throw notFound();
      // Any other failure is left to the page, which reads the query (not this loader's data) and offers a retry.
      // Rethrowing here showed the route error page instead, which has no way back but a reload — including when
      // returning to a product whose query a sign-in/out had just reset.
      return undefined;
    }
  },
  pendingComponent: ProductPageSkeleton,
  component: ProductPage,
});
